import { useRouter } from 'next/router';
import { Cell, Pie, PieChart, Tooltip } from 'recharts';
import { StyledRecharts } from './Recharts.styled';

const NPSCandidates: React.FC = () => {
  const { locale } = useRouter();

  const GRAPH_12_NPS_CUSTOMERS = [
    { name: locale === 'es' ? 'Promotores' : 'Promoters', value: 80 },
    { name: locale === 'es' ? 'Pasivos' : 'Passives', value: 15 },
    { name: locale === 'es' ? 'Detractores' : 'Detractors', value: 5 }
  ];

  return (
    <div>
      <StyledRecharts>
        <PieChart width={170} height={170}>
          <Pie
            data={GRAPH_12_NPS_CUSTOMERS}
            labelLine={false}
            innerRadius={70}
            outerRadius={80}
            dataKey="value"
          >
            <Cell fill="#78D549" />
            <Cell fill="#DE9D1B" />
            <Cell fill="#DE492B" />
          </Pie>
          <Tooltip
            cursor={{ fill: 'transparent' }}
            formatter={(value: number) => value + '%'}
          />
        </PieChart>
      </StyledRecharts>
    </div>
  );
};

export default NPSCandidates;
